export default __webpack_public_path__ + "static/media/onboarding-app-platform-responsive.08772143.png";